// DEPRECATED: This file has been moved to src/utils/supabaseClient.js
// Re-export from the correct location to maintain backward compatibility
console.log('📍 Using supabaseClient redirect from src root');
export { supabase } from './utils/supabaseClient';
